import { HeroTeaser } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";

export const ForbiddenPage = () => {
    const { t } = useTranslation("errors");
    const { auth } = useAuth();

    return (
        <>
            {auth.contractID ? (
                <HeroTeaser
                    noImage
                    buttonText={t("forbidden.button")}
                    onButtonClick={() => {
                        if (auth.contractID) window.location.href = "?ref_id=" + auth.contractID;
                    }}
                    sub={
                        <>
                            <p>{t("forbidden.subtitle")}</p>
                            <p>{t("forbidden.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("forbidden.title")}
                />
            ) : (
                <HeroTeaser
                    noImage
                    sub={
                        <>
                            <p>{t("forbidden.subtitle")}</p>
                            <p>{t("forbidden.subtitle2")}</p>
                            <p>{t("notFound.subtitle3")}</p>
                        </>
                    }
                    title={t("forbidden.title")}
                />
            )}
        </>
    );
};
